import { Link, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

export default function NotFound() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const h1Ref = useRef(null);

  // Set page title and move focus to the heading for a11y
  useEffect(() => {
    document.title = "404 – Page not found";
    // Defer focus until after paint
    const id = setTimeout(() => h1Ref.current?.focus(), 0);
    return () => clearTimeout(id);
  }, [pathname]);

  const canGoBack = typeof window !== "undefined" && window.history?.length > 1;
  const onGoBack = () => (canGoBack ? navigate(-1) : navigate("/", { replace: true }));

  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center text-center px-4"
      aria-labelledby="nf-title"
    >
      <div className="text-7xl md:text-8xl font-extrabold select-none bg-gradient-to-br from-teal-300 via-teal-400 to-emerald-400 bg-clip-text text-transparent">404</div>

      <h1
        id="nf-title"
        ref={h1Ref}
        tabIndex={-1}
        className="mt-4 text-2xl font-semibold text-gray-800"
      >
        Page not found
      </h1>

      <p className="mt-2 text-gray-500">
        The page you’re looking for doesn’t exist or has moved.
      </p>

      <div className="mt-3 text-xs text-gray-500">
        Requested URL:{" "}
        <code className="rounded bg-gray-100 px-2 py-1 text-gray-700">{pathname}</code>
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={onGoBack}
          className="btn-secondary inline-flex items-center px-5 py-2.5 rounded-xl text-sm font-semibold text-slate-700"
          aria-label={canGoBack ? "Go back to previous page" : "Go to dashboard"}
        >
          {canGoBack ? "Go back" : "Go to dashboard"}
        </button>
        <Link
          to="/"
          replace
          className="btn-primary inline-flex items-center px-5 py-2.5 rounded-xl text-sm font-semibold text-white"
          aria-label="Go to dashboard"
        >
          Go to dashboard
        </Link>
      </div>
    </main>
  );
}